
<template>
  <div>
    <v-card color="white lighten-1" class="ma-3" height="">
      <v-card-text>
        <v-form ref="form" :readonly="readonly">
          <v-autocomplete v-model="vehicle.manufacturer" :items="truckBrands" label="Fabricante"
            prepend-icon="mdi-star" hide-no-data :rules="[rules.required]">
            <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
          </v-autocomplete>
          <v-text-field v-model="vehicle.model" label="Modelo" prepend-icon="mdi-truck-delivery"
            :rules="[rules.required]"></v-text-field>
          <v-text-field v-model="vehicle.color" label="Cor" prepend-icon="mdi-palette"
            :rules="[rules.required]"></v-text-field>
          <div v-for="(pl, idx) in plate_count" :key="idx">
            <FileAttachment 
              :key="'idx'"
              class="mb-2" 
              :readonly="readonly" 
              :ref="`attach_${pl}`" 
              :is_creating="is_creating" 
              :update_infos="{API: 'Truck',MODEL:'Truck', id: $route.params.id || '-1'}"
              :attribute_name="`attach_${pl}`" 
              :attached_file_url="vehicle?.[`attach_${pl}_url`]"
              :attachment_text="{add:`Anexo Placa ${pl}`, change:`Alterar Anexo Placa ${pl}`, look:`Ver Anexo Placa ${pl}`}"
            ></FileAttachment>
          </div>
        </v-form>
      </v-card-text>

    </v-card>
  </div>
</template>

<script>

export default {
  name: 'InfoForm',
  props: {
    vehicle:{
      type: Object,
    },
    plate_count:{
      type: Number,
      default: 3
    },
    is_creating:{
      type: Boolean,
      default: false
    },
    readonly:{
      type:Boolean,
      default: false,
    },
  },
  components: {
    FileAttachment: () => import("@/components/shared/FileAttachment.vue"),
  },
  data() {
    return {
      truckBrands: ['Volvo', 'Ford', 'Volkswagen', 'Scania', 'Mercedes-Benz', 'Iveco', 'DAF', 'Outros'],
      rules: {
        required: v => !!v || 'Campo é necessário',
      },
    }
  },
  methods:{
    createFiles(id){
      for(let cont = 1; cont <= this.plate_count; cont++){
        this.$refs[`attach_${cont}`][0].updateFile(id)
      }
    },
    validate(){
      return this.$refs.form.validate()
    },
  }
}
</script>